// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OrdersUsingBundlesByConstraintWeek from './ordersUsingBundlesByConstraintWeek';
import React from 'react';

function OrdersUsingBundlesByConstraintWeekPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-using-bundles-by-constraint-week-page">
            <OrdersUsingBundlesByConstraintWeek />
        </AuthenticatedPage>
    );

}
OrdersUsingBundlesByConstraintWeekPage.displayNAme = 'OrdersUsingBundlesByConstraintWeekPage';

export default OrdersUsingBundlesByConstraintWeekPage;
